import React, { memo } from 'react';
import styled from 'styled-components';

const Text = styled.text`
  font-size: 9px;
  fill: #17181a;
`;

type Props = {
  value: number;
};

const SvgLuggage = ({ value, ...rest }: Props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.5 20.5v-14a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14M7 21.5h10M9 3.726V1h6v2.626"
      stroke="#17181A"
    />
    <path
      clipRule="evenodd"
      d="M5.5 23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      stroke="#17181A"
    />
    <Text dx="7" dy="17.5">
      {value}
    </Text>
  </svg>
);

const Memo = memo(SvgLuggage);
export default Memo;
